import { render, staticRenderFns } from "./PlatformMaintenance.vue?vue&type=template&id=2d4a6c41&scoped=true&"
import script from "./PlatformMaintenance.vue?vue&type=script&lang=ts&"
export * from "./PlatformMaintenance.vue?vue&type=script&lang=ts&"
import style0 from "./PlatformMaintenance.vue?vue&type=style&index=0&id=2d4a6c41&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a6c41",
  null
  
)

export default component.exports